export default __webpack_public_path__ + "static/media/lendIcon.16d478d6.svg";